import React, { createContext, useState, useEffect, useContext } from "react";
import { getAPIURL, setCachedBusiness, getCachedBusiness } from "../lib/utils";
import { withActiveToken } from "../lib/auth";
import { useRouter } from "next/router";
import BusinessContext from "./business-context";
import { renderPegs, renderRows, renderTables } from "../lib/table";

const InstalledPegsContext = createContext({
    getAccountsPeg: () => { },
    accountPeg: null,
    installedPegsTable: null,
    installedPegsRows: [],
    installedPegs: [],
    isLoading: true
});

export const InstalledPegsProvider = (props) => {
    const router = useRouter();
    const [accountPeg, setAccountPeg] = useState(null);
    const { activeBusiness } = useContext(BusinessContext);
    const [installedPegsTable, setInstalledPegsTable] = useState(null);
    const [installedPegsRows, setInstalledPegsRows] = useState([]);
    const [installedPegs, setInstalledPegs] = useState(['space', 'drive', 'developers']);
    const [isLoading, setIsLoading] = useState(true);


    const pegsColumnId = installedPegsTable?.columns?.find(col => col.name === 'pegs')?.id;
    const onError = (error) => {
        console.error(error);
    }

    const fetchInstalledPegRows = (tableId) => {
        const onError = (json) => {
            console.error(json);
        };
        const callback = (json) => {
            setInstalledPegsRows(json);

            console.log(json);



        };
        renderRows(tableId, callback, activeBusiness, onError, router);
    }

    const getInstalledPegsTable = () => {
        const callback = (json) => {
            if (!json || json.length === 0) {
                window.localStorage.setItem(`${activeBusiness.uuid}_installed_pegs`, JSON.stringify([...installedPegs]));
                setIsLoading(false);
                return;
            }
            setInstalledPegsTable(json[0]);
            fetchInstalledPegRows(json[0]?.uuid);
        }
        renderTables(callback, activeBusiness, onError, router, "accounts", null, "installed_pegs");
    }

    const getAccountsPeg = () => {
        const callback = (json) => {
            setAccountPeg(json)
        }
        renderPegs(callback, "accounts", onError, router)
    }

    useEffect(() => {
        if (installedPegsRows && installedPegsRows.length > 0 && activeBusiness) {
            const installedPegsFromRows = installedPegsRows.flatMap(row => {
                const pegsData = row.data?.[pegsColumnId];
                if (!pegsData) return [];
                return Array.isArray(pegsData)
                    ? pegsData.map(peg => typeof peg === 'string' ? peg.toLowerCase() : peg)
                    : [typeof pegsData === 'string' ? pegsData.toLowerCase() : pegsData];
            });
            const updatedPegs = [...new Set([...installedPegs, ...installedPegsFromRows || []])];
            setInstalledPegs(updatedPegs);
            window.localStorage.setItem(`${activeBusiness.uuid}_installed_pegs`, JSON.stringify(updatedPegs));
            setIsLoading(false);

            console.log(installedPegsFromRows);
        }

    }, [installedPegsRows]);

    useEffect(() => {
        if (activeBusiness) {
            const cachedPegs = window.localStorage.getItem(`${activeBusiness.uuid}_installed_pegs`);
            if (cachedPegs) {
                setInstalledPegs(JSON.parse(cachedPegs));
            }
            getInstalledPegsTable();
        }
    }, [activeBusiness]);

    const context = {
        getAccountsPeg,
        accountPeg,
        installedPegsTable,
        installedPegsRows,
        installedPegs,
        isLoading
    };

    return (
        <InstalledPegsContext.Provider value={context}>
            {props.children}
        </InstalledPegsContext.Provider>
    );
};

export default InstalledPegsContext;
